import * as React from "react";
const SvgFiRrToken = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-token_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6m4.151-7.523a.71.71 0 0 1-.206.778l-1.656 1.351.687 2.083a.69.69 0 0 1-.237.771.7.7 0 0 1-.809.031l-1.923-1.251-1.892 1.267a.7.7 0 0 1-.389.114v-.008a.694.694 0 0 1-.664-.908l.656-2.106-1.663-1.351a.7.7 0 0 1-.206-.771.7.7 0 0 1 .656-.458h2.098l.74-1.992a.7.7 0 0 1 1.312 0l.74 1.992h2.098a.7.7 0 0 1 .656.458z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-token_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToken;
